import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'
import { useViewport } from '../../../containers/useViewport'

import './heroVideo.css'

const HeroVideo = ({ data }) => {
  const { width } = useViewport()
  const player = useRef(null)

  const video = data.mobileVideo && width / 16 < 48 ? data.mobileVideo : data.video

  return (
    <section
      className={
        'heroVideo' + (data.constrain ? ' constrain' : '') + (data.mobileVideo ? ' hasMobile' : '')
      }
    >
      <div className="videoWrapper">
        <div className="innerWrap">
          <div data-vjs-player>
            <ReactPlayer
              ref={player}
              className="heroVideo--video"
              url={video}
              playing
              muted
              volume={0}
              loop
              controls={false}
              playsinline
              width={null}
              height={null}
              config={{
                youtube: {
                  playerVars: {
                    controls: 0,
                    fs: 0,
                    iv_load_policy: 3,
                    modestbranding: 1,
                  },
                },
                vimeo: {
                  playerOptions: {
                    playsinline: true,
                    background: true,
                  },
                },
              }}
            ></ReactPlayer>
          </div>
        </div>
      </div>

      <div className="content">
        <h2>{data.text}</h2>
      </div>
    </section>
  )
}

HeroVideo.propTypes = {
  data: PropTypes.object,
}
HeroVideo.defaultProps = {
  data: {
    text: '',
    video: null,
    constrain: true,
  },
}

export default HeroVideo
